<template>
  <div>
    <!-- Filtres -->
    <div>
      <v-container class="pa-2">
        <v-row>
          <v-col justify="end" align="center">
            <v-menu
              v-model="period_format_menu"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="dades_filter_btn"
                >
                  {{ period_format_text }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="item in period_options"
                  :key="item.text"
                  @click="period_format = item.value; filter_format_menu = false"
                >
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

          </v-col>
          <v-col justify="end" align="center">

            <div>
              <!-- Specific date picker -->
              <v-menu
                v-model="filter_date_menu"
                :close-on-content-click="false"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="dades_filter_btn"
                  >
                    {{ display_filter_date }}
                  </v-btn>
                </template>

                <v-date-picker
                  v-model="filter_date"
                  :type="period_format == 'day' ? 'date' : 'month'"
                  no-title
                  scrollable
                  locale="ca-ES"
                  first-day-of-week="1"
                  v-if="period_format != 'year'"
                  class="dades_filter_width"
                ></v-date-picker>

                <v-list v-else>
                  <v-list-item
                    v-for="item in filter_date_years"
                    :key="item.text"
                    @click="filter_date = item.value; filter_date_menu = false"
                    class="dades_filter_width"
                  >
                    <v-list-item-title>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

          </v-col>
          <v-col justify="end" align="center">

            <v-select
              v-model="colfilter"
              :items="allheaders.slice(1,99)"
              item-text="text"
              item-value="value"
              multiple
              solo
              color="primary"
              background-color="primary"
              class="dades_select_valors"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3" color="#edc4cb">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span
                  v-if="index === 3"
                  class="white--text text-caption"
                >
                  (+{{ colfilter.length - 3 }} més)
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="table-cont pa-4">
      <v-data-table
        dense
        :headers="headers"
        :items="table_data"
        :items-per-page="99999"
        item-key="name"
        locale="ca-ES"
        :header-props="{'sort-by-text': 'Ordenar per'}"
        hide-default-footer
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-arrow-left',
          nextIcon: 'mdi-arrow-right',
          'items-per-page-text': 'Registres per pàgina'
        }"
      >

        <!-- Datetime -->
        <template v-slot:item.date="{ item }">
          <span>{{ format_date_row(item.date) }}</span>
        </template>

      </v-data-table>
    </div>
  </div>
</template>

<script>
 import utils from '@/utils';
 import units from '@/units';
 import { mapState, mapActions } from 'vuex';

 export default {
   name: 'Dades',

   components: {
   },

   data: function() {
     const headers_common = {
       "class": "white--text",
     };

     return {
       unit: 'hour',
       filter_date_menu: false,
       filter_date: '2022-06-29',
       start: utils.defaultDateRange()[0],
       end: utils.defaultDateRange()[1],
       period_options: [
         {value: 'day',   text: 'Diàries'},
         {value: 'month', text: 'Mensuals'},
         {value: 'year',  text: 'Anuals'},
       ],
       period_format: 'day',
       period_format_menu: false,
       allheaders: [
         {...headers_common, value: 'date', text: 'Data'},
         {...headers_common, value: 'temp_min', text: 'Temp °C min'},
         {...headers_common, value: 'temp_avg', text: 'Temp °C mitjana'},
         {...headers_common, value: 'temp_max', text: 'Temp °C max'},
         {...headers_common, value: 'hum_min', text: 'Humitat min'},
         {...headers_common, value: 'hum_avg', text: 'Humitat mitjana'},
         {...headers_common, value: 'hum_max', text: 'Humitat max'},
         {...headers_common, value: 'rain_rate_min', text: 'Pluja min'},
         {...headers_common, value: 'rain_rate_avg', text: 'Pluja mitjana'},
         {...headers_common, value: 'rain_rate_max', text: 'Pluja maxmm'},
         {...headers_common, value: 'rain_sum', text: 'Pluja total agregat'},
         {...headers_common, value: 'wind_speed_min', text: 'Vent min m/s'},
         {...headers_common, value: 'wind_speed_avg', text: 'Vent mitjà m/s'},
         {...headers_common, value: 'wind_speed_max', text: 'Vent max m/s'},
         {...headers_common, value: 'wind_dir_avg', text: 'Direcció del vent'},
         {...headers_common, value: 'uv_index_min', text: 'Índex UV min'},
         {...headers_common, value: 'uv_index_avg', text: 'Índex UV mitja'},
         {...headers_common, value: 'uv_index_max', text: 'Índex UV max'},
         {...headers_common, value: 'bar_absolute_min', text: 'Pressió min hPa'},
         {...headers_common, value: 'bar_absolute_avg', text: 'Pressió mitjana hPa'},
         {...headers_common, value: 'bar_absolute_max', text: 'Pressió max hPa'},
       ],
       colfilter: [
         'temp_min',
         'temp_max',
         'wind_dir_avg',
         'rain_sum',
         'bar_absolute_avg',
         'hum_min',
         'hum_max',
         'wind_speed_avg',
       ],
     };
   },

   mounted() {
     this.filter_date = (new Date()).toISOString().split('T')[0];
   },

   computed: {
     ...mapState([
       'data',
       'data_unit',
     ]),

     filter_date_years() {
       // [{value: '2022-01-01', text: '2021'}]
       const res = [];
       let now   = 2021;
       let end   = new Date().getFullYear();
       while (now <= end)
         res.push(now++);
       return res.reverse().map(x => ({
         value: `${x}-01-01`,
         text: x,
       }));
     },

     table_data() {
       return (this.data ? this.data : []).map(e => units.table_format(e));
     },

     headers() {
       return this.allheaders.filter(h => h.value == 'date' || this.colfilter.indexOf(h.value) >= 0)
     },

     period_format_text() {
       return (this.period_options.filter(
         x => x.value == this.period_format
       ) || [{text: 'Periòde'}])[0].text;
     },

     display_filter_date() {
       let dt = new Date(this.filter_date)
       if (this.period_format == 'month')
         return units.date2locale_date_yymm(dt);
       else if (this.period_format == 'year')
         return dt.getFullYear();
       return units.date2locale_date_yymmdd(dt);
     },
   },

   methods: {
     ...mapActions([
       'LOAD_DATA',
     ]),

     format_date_row(date) {
       if (this.unit == 'hour')
         return utils.left_pad(''+date.getHours(), '0', 2) + 'h';
       if (this.unit == 'day')
         return (utils.left_pad(''+date.getDate(), '0', 2)
               + '. ' + units.date2weekday(date));
       if (this.unit == 'month')
         return units.date2monthname(date);
     },

     change(start, end) {
       this.start = start;
       this.end   = end;

       let diffdays = (end - start) / (1000 * 3600 * 24);

       if (diffdays < 7)
         this.unit = 'hour';
       else if (diffdays < 7*31)
         this.unit = 'day';
       else
         this.unit = 'month';

       this.LOAD_DATA({unit: this.unit, start: this.start, end: this.end});
     },
   },

   watch: {
     filter_date(raw_date) {
       let dt  = new Date(raw_date);
       let end = null;
       if (this.period_format == 'month')
         end = new Date(dt.getFullYear(), dt.getMonth() + 1, 0, 23, 59);
       else if (this.period_format == 'year')
         end = new Date(dt.getFullYear(), 12, 31, 23, 59);
       else // day
         end = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59);
       this.change(dt, end);
     }
   }
 };
</script>

<style>
 .table-cont {
 }

 .v-data-table-header {
   background-color: #880016;
 }

 .dades_select_valors {
   /* background-color: #880016; */
 }

 .dades_filter_btn {
   width: 25em;
 }

 .dades_filter_width {
   width: 22em;
 }
</style>
